import { view } from "@risingstack/react-easy-state";
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Select from 'react-select';
import GenericPageContainer from '../../../GenericPageElements/GenericPageContainer'
import request from "../../../helpers/request";
import endpoints from "../../../helpers/endpoints";
import ReactModal from 'react-modal'
import DatePicker from "../../../components/date-picker/DatePicker";
import moment from 'moment';
import 'moment/locale/en-gb';
import Pagination from '../../../components/pagination/pagination';
import modules from "../../../assets/modules-map.json"
import { formatDate } from "../../../helpers/formatDate";
import measureOptions from "../../../helpers/measureOptions.json";

export default view(function DataCleanseValidationAssurance() {
    const [users, setUsers] = useState([])
    const [workflowItems, setWorkflowItems] = useState([])
    const [loadingWorkflow, setLoadingWorkflow] = useState(false)

    const [fromTime, setFromTime] = useState(moment().utc().locale('en-gb').subtract(7, 'days').startOf('day'));
    const [toTime, setToTime] = useState(moment().utc().locale('en-gb').startOf('day'));
    const [selectedUser, setSelectedUser] = useState()
    const [selectedMeasure, setSelectedMeasure] = useState({})
    const [measureExplanations, setMeasureExplanations] = useState([])
    const [selectedMeasureExplanation, setSelectedMeasureExplanation] = useState()
    const [selectedStatus, setSelectedStatus] = useState()
    const [selectedModule, setSelectedModule] = useState();
    const [page, setPage] = useState()
    const [lastPage, setLastPage] = useState()
    const [search, setSearch] = useState('')
    const [commentModalSettings, setCommentModalSettings] = useState({isOpen: false, measureType: '', measureComment: ''})
    const [bulkRejectModelOpen, setBulkRejectModelOpen] = useState(false)
    const [loadingReject, setLoadingReject] = useState(false)
    const table = useRef(null);

    const measures = [{label: 'All Measures', value: ''}, { label: 'Address', value: 'ADDRESS' }, { label: 'UPRN', value: 'UPRN' }, { label: 'VOA', value: 'VOA' }, { label: 'LTV', value: 'LTV' }, { label: 'VWC', value: 'VWC' }];

    useEffect(() => {
        var initialMeasureExplanation = [{label: 'All Measures', value: ''}]
        setSelectedMeasureExplanation(initialMeasureExplanation)
        if (selectedMeasure.value === "ADDRESS") {
            initialMeasureExplanation = initialMeasureExplanation.concat(measureOptions.address_options)
        } else if (selectedMeasure.value === "UPRN") {
            initialMeasureExplanation = initialMeasureExplanation.concat(measureOptions.uprn_options)
        } else if (selectedMeasure.value === "VOA") {
            initialMeasureExplanation = initialMeasureExplanation.concat(measureOptions.voa_options)
        } else if (selectedMeasure.value === "LTV") {
            initialMeasureExplanation = initialMeasureExplanation.concat(measureOptions.ltv_options)
        } else if (selectedMeasure.value === "VWC") {
            initialMeasureExplanation = initialMeasureExplanation.concat(measureOptions.vwc_options)
        }
        setMeasureExplanations(initialMeasureExplanation)
    }, [selectedMeasure])

    const getWorkflowItems = () => {
        if (!selectedUser) {
            setPage()
            return
        }
        setLoadingWorkflow(true)
        request(true).get(endpoints.DATA_CLEANSE_VALIDATION_ASSURANCE_ITEMS + '?page=' + page, {
            doesCancel: true,
            params: {
                spid: search,
                user: selectedUser?.value,
                module: selectedModule?.value,
                fromTime: fromTime,
                toTime: toTime,
                ...(selectedStatus && { selectedStatus: selectedStatus?.value }),
                ...(selectedMeasure && { measure: selectedMeasure.value }),
                ...(selectedMeasureExplanation && { measureExplanation: selectedMeasureExplanation.value }),
            }
        }).then(e => {
            setWorkflowItems(e.data.data ?? []);
            setLoadingWorkflow(false);
            if (e.data.current_page !== page) {
                setPage(e.data.current_page)
            }
            setLastPage(e.data.last_page)
        }).catch(e => {
            console.log(e);
            window.alert('Could not retrieve data')
            setLoadingWorkflow(false)
        })
    }

    useEffect(() => {
        request(true).get(endpoints.DATA_CLEANSE_VALIDATION_QA_USERS).then(r => {
            setUsers(Object.keys(r.data).map(key => { return { label: r.data[key], value: key } }))
        })
    }, [])

    useEffect(() => {
        if (!selectedUser) return
        setPage(0)
        setSearch(null)
    }, [selectedUser, selectedModule, selectedStatus, fromTime, toTime, selectedMeasure, selectedMeasureExplanation])

    useEffect(() => {
        if (page === 0) {
            setPage(1)
        } else {
            getWorkflowItems()
        }
    }, [page])

    useEffect(() => {
        if (search !== null) {
            getWorkflowItems()
        }
    }, [search])

    return (
        <GenericPageContainer
            className={'DCV-Assurance'}
            containerWidth={"95vw"}
            title="Data Cleanse Validation - Assurance"
            titleIconClass={"fak fa-id-business-icon fa-2x colour-primary"}
            titleRight={
                <div>
                    <Link className="navigate" to="/portal/data-cleanse-validation">
                        To Summary
                    </Link>
                    <Link className="navigate" to="/portal/data-cleanse-validation/quality-assurance">
                        To Quality Assurance
                    </Link>
                </div>
            }
        >
            <div class="quality-assurance" style={{ gridTemplateColumns: '1fr 1fr 1fr 1fr', marginBottom: '10px' }}>
                <div>
                    <p className="font-weight-600">User</p>
                    <Select
                        options={[{ label: 'All Users', value: '' }].concat(users)}
                        onChange={setSelectedUser}
                        styles={{
                            container: (baseStyles, state) => ({
                                ...baseStyles,
                                display: 'grid'
                            }),
                        }}
                    />
                </div>
                <div>
                    <p className="font-weight-600">Module</p>
                    <Select
                        options={modules}
                        onChange={setSelectedModule}
                        defaultValue={{ label: 'All Modules', value: '' }}
                        styles={{
                            container: (baseStyles, state) => ({
                                ...baseStyles,
                                display: 'grid'
                            }),
                        }}
                    />
                </div>
                <div>
                    <p className="font-weight-600">Measure</p>
                    <Select
                        options={measures}
                        onChange={setSelectedMeasure}
                        defaultValue={{ label: 'All Measures', value: '' }}
                        styles={{
                            container: (baseStyles, state) => ({
                                ...baseStyles,
                                display: 'grid'
                            }),
                        }}
                    />
                </div>
                <div>
                    <p className="font-weight-600">Explanation</p>
                    <Select
                        options={measureExplanations}
                        onChange={setSelectedMeasureExplanation}
                        value={selectedMeasureExplanation}
                        defaultValue={{ label: 'All Measures', value: '' }}
                        styles={{
                            container: (baseStyles, state) => ({
                                ...baseStyles,
                                display: 'grid'
                            }),
                        }}
                    />
                </div>
                <div>
                    <p className="font-weight-600">From</p>
                    <DatePicker time={fromTime} disableFuture={true} onChange={date => setFromTime(date)} />
                </div>
                <div>
                    <p className="font-weight-600">To</p>
                    <DatePicker time={toTime} disableFuture={true} onChange={date => setToTime(date)} />
                </div>
                <div>
                    <p className="font-weight-600">Status</p>
                    <Select
                        options={[{ label: 'All Statuses', value: '' }, { label: 'Assured', value: 'Assured' }, { label: 'Quality Check Passed', value: 'Quality Check Passed' }]}
                        onChange={setSelectedStatus}
                        defaultValue={{ label: 'All Statuses', value: '' }}
                        styles={{
                            container: (baseStyles, state) => ({
                                ...baseStyles,
                                display: 'grid'
                            }),
                        }}
                    />
                </div>
                <div>
                    <p className="font-weight-600">Core SPID</p>
                    <input type="text" onChange={e => setSearch(e.target.value)} value={search ?? ''} placeholder="Search..." style={{ height: '100%', alignSelf: 'end' }} />
                </div>
            </div>
            <table ref={table} className='table borders squish smaller-text'>
                <thead>
                    <tr>
                        <th>Core SPID</th>
                        <th>Module</th>
                        <th>Status</th>
                        <th>User</th>
                        <th>Insert Date</th>
                        <th>Address Explanation</th>
                        <th>UPRN Explanation</th>
                        <th>VOA Explanation</th>
                        <th>LTV Explanation</th>
                        <th>VWC Explanation</th>
                    </tr>
                </thead>
                <tbody>
                    { loadingWorkflow ? (
                        <tr>
                            <td colSpan="11">
                                <i className="fa fa-spinner fa-spin" />
                            </td>
                        </tr>
                    ) : workflowItems.length > 0 ? (
                        workflowItems.map(row => (
                            <tr key={row.Core_SPID}>
                                <td>{row.Core_SPID}</td>
                                <td>{modules.find(module => module.value === row.Module)?.label}</td>
                                <td>{row.WS_Outcome}</td>
                                <td>{users.find(user => user.value === row.User_ID)?.label}</td>
                                <td>{row.Insert_Date}</td>
                                <td>{row.ADDRESS_Measure}</td>
                                {
                                    ['UPRN', 'VOA'].map(measure => {
                                        return (
                                            row[`${measure}_Measure`] === "Verified Non-Addressable: Other (Please Comment)" ?
                                                <td 
                                                className="measure-comment-link"
                                                onClick={() => {
                                                    setCommentModalSettings({isOpen: true, measureComment: row[`${measure}_Measure_Comment`], measureType: `${measure} Measure Comment`})
                                                }}>
                                                    {row[`${measure}_Measure`]}
                                                </td>
                                            :
                                                <td>
                                                    {row[`${measure}_Measure`]}
                                                </td>
                                        )
                                    })
                                }
                                <td>{row.LTV_Measure}</td>
                                <td>{row.VWC_Measure}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            {Array.from(table.current?.rows[0].cells ?? []).map((cell, index) => (
                                <td key={index}></td>
                            ))}
                        </tr>
                    )}
                </tbody>
            </table>
            { workflowItems.length > 0 && lastPage > 1 &&
                <Pagination page={page} pages={lastPage} pageChange={(page) => setPage(page)}/>
            }
            <button 
                className={`button compact smaller-text reject ${selectedUser && !loadingWorkflow && workflowItems.length > 0 && 'cancel'}`}
                style={{ marginLeft: 'auto', width: '10em' }}
                disabled={!selectedUser || loadingWorkflow || workflowItems.length < 1}
                onClick={() => {
                    setBulkRejectModelOpen(true);
                }}
            >Bulk Reject</button>
            <ReactModal 
            isOpen={commentModalSettings.isOpen} 
            onRequestClose={() => setCommentModalSettings({...commentModalSettings, isOpen: false})}
            className="card bulk-allocate"
            contentLabel="Measure Comment"
            style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' }, content: { position: 'relative' } }}>
                <div style={{ position: 'absolute', right: '1em', top: '0.5em', cursor: 'pointer' }} onClick={() => setCommentModalSettings({...commentModalSettings, isOpen: false})}>
                    <i class="fa-solid fa-xmark"></i>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
                    <h3>{commentModalSettings.measureType}</h3>
                    <p>{commentModalSettings.measureComment}</p>
                </div>
            </ReactModal>
            <ReactModal
            isOpen={bulkRejectModelOpen} 
            onRequestClose={() => setBulkRejectModelOpen(false)}
            className="card bulk-reject"
            contentLabel="Data Cleanse Validation - Bulk Reject"
            style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}>
                <div className='dcv-reject'>
                    <p>
                        You are about to reject {workflowItems.length} submission{workflowItems.length > 1 && 's'} due to quality concerns. This action<br />
                        will return the work to the user's workflow queue for further review or updates.<br />
                        Please ensure you have carefully reviewed your selections click "Confirm" if you<br />
                        are ready to proceed.
                    </p>
                    <div>
                        <button className="button smaller-text cancel" onClick={ () => setBulkRejectModelOpen(false) }>Cancel</button>
                        <button className="button smaller-text background-primary colour-white" onClick={() => {
                            setLoadingReject(true)
                            request(true).post(endpoints.DATA_CLEANSE_VALIDATION_BULK_REJECT_ASSURANCE, {
                                spid: search,
                                user: selectedUser?.value,
                                module: selectedModule?.value,
                                fromTime: fromTime,
                                toTime: toTime,
                                ...(selectedStatus && { selectedStatus: selectedStatus?.value }),
                                ...(selectedMeasure && { measure: selectedMeasure.value }),
                                ...(selectedMeasureExplanation && { measureExplanation: selectedMeasureExplanation.value }),
                            }).then(r => {
                                setLoadingReject(false)
                                setBulkRejectModelOpen(false); 
                                getWorkflowItems();
                            }).catch(error => {
                                console.log(error)
                                setLoadingReject(false)
                            })
                        }}
                        >
                            { !loadingReject ?
                                "Confirm"
                            :
                                <div className="spinner" style={{ margin: '0em 1em' }}>
                                <i className="fa fa-spinner fa-spin"></i>
                                </div>
                            }
                        </button> 
                    </div>
                </div>
            </ReactModal>
        </GenericPageContainer>
    )
})